// StartMarker — marks where the run's path begins (first node of actualPath).
// Counterpart of TerminusBadge (the exit). Rendered above nodes.

import type { NodePosition } from './layoutEngine.ts';

export default function StartMarker({ pos }: { pos: NodePosition }) {
  const nodeX = pos.x + 6;
  const w = 44;
  const h = 14;
  const x = nodeX;
  const y = pos.y - h - 4;
  return (
    <g data-testid="start-marker" pointerEvents="none">
      <title>Run start — the first step of the walked path</title>
      <rect
        x={x}
        y={y}
        width={w}
        height={h}
        rx={7}
        fill="var(--bg-pill)"
        stroke="var(--green)"
        strokeWidth={1}
      />
      <text
        x={x + w / 2}
        y={y + h / 2 + 0.5}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="var(--green)"
        fontSize="8"
        fontWeight={700}
        fontFamily="'JetBrains Mono', monospace"
      >
        ▶ START
      </text>
    </g>
  );
}
